function _inheritsLoose(a, b) {
  a.prototype = Object.create(b.prototype), a.prototype.constructor = a, a.__proto__ = b;
}
/* eslint-disable react/no-unused-prop-types */

/* eslint-disable react/forbid-prop-types */


import * as vega from "vega";
import PropTypes from "prop-types";
import React from "react";
import { capitalize, isDefined, isFunction } from "./util";

var propTypes = {
  background: PropTypes.string,
  className: PropTypes.string,
  data: PropTypes.object,
  enableHover: PropTypes.bool,
  height: PropTypes.number,
  logLevel: PropTypes.number,
  onNewView: PropTypes.func,
  onParseError: PropTypes.func,
  padding: PropTypes.object,
  renderer: PropTypes.string,
  spec: PropTypes.object.isRequired,
  style: PropTypes.object,
  tooltip: PropTypes.func,
  width: PropTypes.number
},
    defaultProps = {
  background: void 0,
  className: "",
  data: {},
  enableHover: !0,
  height: void 0,
  logLevel: void 0,
  onNewView: function onNewView() {},
  onParseError: function onParseError() {},
  padding: void 0,
  renderer: "svg",
  style: void 0,
  tooltip: function tooltip() {},
  width: void 0
},
    Vega =
/*#__PURE__*/
function (a) {
  function b() {
    return a.apply(this, arguments) || this;
  }

  _inheritsLoose(b, a), b.isSamePadding = function isSamePadding(c, a) {
    return isDefined(c) && isDefined(a) ? c.top === a.top && c.left === a.left && c.right === a.right && c.bottom === a.bottom : c === a;
  }, b.isSameData = function isSameData(c, a) {
    return c === a && !isFunction(c);
  }, b.isSameSpec = function isSameSpec(c, a) {
    return c === a || JSON.stringify(c) === JSON.stringify(a);
  }, b.listenerName = function listenerName(a) {
    return "onSignal" + capitalize(a);
  };
  var c = b.prototype;
  return c.componentDidMount = function componentDidMount() {
    var a = this.props.spec;
    this.createView(a);
  }, c.componentDidUpdate = function componentDidUpdate(a) {
    var c = this,
        d = this.props.spec;
    if (d !== a.spec) this.clearView(), this.createView(d);else if (this.view) {
      var e = this.props,
          f = !1;
      ["width", "height", "renderer", "logLevel", "background"].filter(function (b) {
        return e[b] !== a[b];
      }).forEach(function (a) {
        c.view[a](e[a]), f = !0;
      }), b.isSamePadding(e.padding, a.padding) || (this.view.padding(e.padding || d.padding), f = !0), d.data && e.data && d.data.forEach(function (g) {
        var d = a.data[g.name],
            h = e.data[g.name];
        b.isSameData(d, h) || (c.updateData(g.name, h), f = !0);
      }), e.enableHover !== a.enableHover && (f = !0), f && (e.enableHover && this.view.hover(), this.view.run());
    }
  }, c.componentWillUnmount = function componentWillUnmount() {
    this.clearView();
  }, c.createView = function createView(a) {
    var c = this;

    if (a) {
      var e = this.props; // Parse the vega spec and create the view

      try {
        var f = vega.parse(a),
            g = new vega.View(f).initialize(this.element);
        a.signals && a.signals.forEach(function (a) {
          g.addSignalListener(a.name, function () {
            var d = e[b.listenerName(a.name)];

            if (d) {
              for (var f = arguments.length, g = Array(f), h = 0; h < f; h++) {
                g[h] = arguments[h];
              }

              d.apply(c, g);
            }
          });
        }), this.view = g, ["logLevel", "renderer", "tooltip", "background", "width", "height", "padding"].filter(function (a) {
          return isDefined(e[a]);
        }).forEach(function (a) {
          g[a](e[a]);
        }), a.data && e.data && a.data.filter(function (a) {
          return e.data[a.name];
        }).forEach(function (a) {
          c.updateData(a.name, e.data[a.name]);
        }), e.enableHover && g.hover(), g.run(), e.onNewView(g);
      } catch (a) {
        this.clearView(), e.onParseError(a);
      }
    } else this.clearView();

    return this;
  }, c.updateData = function updateData(a, b) {
    b && (isFunction(b) ? b(this.view.data(a)) : this.view.change(a, vega.changeset().remove(function () {
      return !0;
    }).insert(b)));
  }, c.clearView = function clearView() {
    return this.view && (this.view.finalize(), this.view = null), this;
  }, c.render = function render() {
    var a = this,
        b = this.props,
        c = b.className,
        d = b.style;
    return (// Create the container Vega draws inside
      React.createElement("div", {
        ref: function ref(b) {
          a.element = b;
        },
        className: c,
        style: d
      })
    );
  }, b;
}(React.Component);

Vega.propTypes = propTypes, Vega.defaultProps = defaultProps;
export default Vega;